import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';

import { WindowService } from 'src/shared/providers/window.service';

@Component({
  templateUrl: './access.page.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AccessPage {
  readonly windowService = inject(WindowService);
}
